import React from "react";
import TreatmentPlansPage from "./TreatmentPlans";

export default function TreatmentPlansAccountReceivable() {
  return <TreatmentPlansPage />;
}
